import React from 'react';
import './BankSyncModal.css';
import './BankSyncAllModal.css';

// Fragt Konten sequentiell ab (nicht parallel), da jede Bank ein eigenes PIN
// und ggf. eine eigene TAN braucht - das muss der Nutzer pro Konto einzeln
// eingeben. PIN/TAN leben wie bei BankSyncModal nur lokal in diesem State.
export default function BankSyncAllModal(props) {

	const x = props.x;

	const [accounts, setAccounts] = React.useState(null);
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const [pin, setPin] = React.useState('');
	const [tanCode, setTanCode] = React.useState('');
	const [fintsState, setFintsState] = React.useState('');
	const [challenge, setChallenge] = React.useState(null);
	const [busy, setBusy] = React.useState(false);
	const [error, setError] = React.useState('');

	React.useEffect(() => {
		x.was.axGet('Backend/webapp.php?module=Banking&task=BankingConnectionList', (result) => {
			if (result.data.returncode === 1) {
				setAccounts(result.data.content
					.filter((c) => parseInt(c.disabled, 10) !== 1)
					.map((c) => ({
						connectionId: c.connectionid,
						label: c.bankname + ' - ' + c.accountlabel,
						status: 'pending',
						message: '',
					})));
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const current = (accounts && currentIndex < accounts.length) ? accounts[currentIndex] : null;
	const allDone = accounts !== null && currentIndex >= accounts.length;

	function updateCurrent(patch) {
		setAccounts((list) => list.map((a, i) => (i === currentIndex ? { ...a, ...patch } : a)));
	}

	function advance() {
		setPin('');
		setTanCode('');
		setFintsState('');
		setChallenge(null);
		setError('');
		setCurrentIndex((i) => i + 1);
	}

	function skipCurrent() {
		updateCurrent({ status: 'skipped' });
		advance();
	}

	function submitPin() {
		if (pin === '' || !current) return;
		setBusy(true);
		setError('');
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingSync', {
			connectionId: current.connectionId,
			pin: pin,
		}, handleResult);
	}

	function submitTan() {
		if (tanCode === '' || !current) return;
		setBusy(true);
		setError('');
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingSync', {
			connectionId: current.connectionId,
			pin: pin,
			tanCode: tanCode,
			fintsState: fintsState,
		}, handleResult);
	}

	function handleResult(result) {
		setBusy(false);
		if (result.data.returncode !== 1) {
			const message = (result.data.content && result.data.content.message) || 'Abruf fehlgeschlagen.';
			updateCurrent({ status: 'error', message });
			advance();
			return;
		}
		const content = result.data.content;
		if (content.status === 'tan-required') {
			updateCurrent({ status: 'tan-required' });
			setChallenge({ text: content.challenge, tanMediumName: content.tanMediumName });
			setFintsState(content.fintsState);
			setTanCode('');
			return;
		}
		updateCurrent({ status: 'success', message: content.transactionCount + ' neue Umsätze' });
		advance();
	}

	function close() {
		setPin('');
		setTanCode('');
		setFintsState('');
		props.onClose();
	}

	return (
		<div className="banking-sync-overlay">
			<div className="banking-sync-modal banking-sync-all-modal">
				<div className="banking-sync-header">
					<span>Umsätze aller Konten abrufen</span>
					<i className="bi bi-x-lg table-icon" onClick={close}></i>
				</div>
				<div className="banking-sync-body">
					{accounts === null &&
						<p>Lade Konten…</p>
					}
					{accounts !== null && accounts.length === 0 &&
						<p>Keine aktiven Bankverbindungen vorhanden.</p>
					}
					{accounts !== null && accounts.length > 0 &&
						<ul className="banking-sync-all-list">
							{accounts.map((a, i) => (
								<li key={a.connectionId} className={`banking-sync-all-item status-${a.status}`}>
									<span className="banking-sync-all-label">{a.label}</span>
									<span className="banking-sync-all-status">
										{a.status === 'success' && <><i className="bi bi-check-circle-fill"></i> {a.message}</>}
										{a.status === 'error' && <><i className="bi bi-exclamation-triangle-fill"></i> {a.message}</>}
										{a.status === 'skipped' && 'übersprungen'}
										{a.status === 'tan-required' && 'TAN erforderlich…'}
										{a.status === 'pending' && i === currentIndex && 'läuft…'}
									</span>
								</li>
							))}
						</ul>
					}

					{current && challenge === null &&
						<div className="banking-sync-all-active">
							<label htmlFor="banking-sync-all-pin">PIN für {current.label}</label>
							<input
								id="banking-sync-all-pin"
								type="password"
								autoComplete="off"
								value={pin}
								onChange={(e) => setPin(e.target.value)}
								onKeyDown={(e) => { if (e.key === 'Enter') submitPin(); }}
								autoFocus
							/>
							{error !== '' && <p className="banking-sync-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
							<div className="banking-sync-all-actions">
								<button type="button" className="btn" disabled={busy || pin === ''} onClick={submitPin}>
									{busy ? 'Verbinde…' : 'Abrufen'}
								</button>
								<button type="button" className="btn" disabled={busy} onClick={skipCurrent}>
									Überspringen
								</button>
							</div>
						</div>
					}

					{current && challenge !== null &&
						<div className="banking-sync-all-active">
							{challenge.text && <p className="banking-sync-challenge">{challenge.text}</p>}
							{challenge.tanMediumName && <p className="banking-sync-medium">Gerät: {challenge.tanMediumName}</p>}
							<label htmlFor="banking-sync-all-tan">TAN für {current.label}</label>
							<input
								id="banking-sync-all-tan"
								type="text"
								autoComplete="off"
								value={tanCode}
								onChange={(e) => setTanCode(e.target.value)}
								onKeyDown={(e) => { if (e.key === 'Enter') submitTan(); }}
								autoFocus
							/>
							<div className="banking-sync-all-actions">
								<button type="button" className="btn" disabled={busy || tanCode === ''} onClick={submitTan}>
									{busy ? 'Bestätige…' : 'TAN bestätigen'}
								</button>
							</div>
						</div>
					}

					{allDone &&
						<div className="banking-sync-all-actions">
							<button type="button" className="btn" onClick={props.onSuccess}>Fertig</button>
						</div>
					}
				</div>
			</div>
		</div>
	)

};
